
import { Component, ChangeDetectionStrategy, ViewEncapsulation, HostListener, ElementRef, AfterViewInit, OnDestroy, Output, EventEmitter, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterDetailEditorBodyDirective, MasterDetailEditorComponent, MasterDetailEditorDisplayMode, MasterDetailEditorFooterDirective, MasterDetailEditorLeftActionsDirective, MasterDetailEditorRightActionsDirective } from '@workbuddy/ui/blocks/master.detail.editor';
import { DialogService } from '@workbuddy/ui/services';
import { UploadFieldComponent } from '@workbuddy/ui/fields/upload';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Activity, ActivityKind, ActivityType, Entity, LabelType, Shareable } from '@jms/model';
import { tap } from 'rxjs';
import { ButtonComponent } from '@workbuddy/ui/components/button';
import { FilesContext } from '../../model';
import { CurrentUserService } from '@jms/ui/ui.standalone.services/current.user.service';
import { DateTime } from 'luxon';
import { SharingProComponent } from '@workbuddy/ui/fields/sharing.pro';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { SignalInput } from '@workbuddy/utils/signals';
import { SelectComponent } from '@workbuddy/ui/fields/select';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'file-upload-editor',
    templateUrl: 'file.upload.editor.component.html',
    styleUrls: ['file.upload.editor.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,

        MasterDetailEditorComponent,
        MasterDetailEditorBodyDirective,

        MasterDetailEditorLeftActionsDirective,
        MasterDetailEditorRightActionsDirective,

        MasterDetailEditorFooterDirective,

        UploadFieldComponent,
        ButtonComponent,
        SharingProComponent,
        SelectComponent

    ]
})

export class FileUploadEditorComponent implements AfterViewInit, OnDestroy {

    @SignalInput() @Input('context') public $context = signal<FilesContext>(null);
    @Output() public save = new EventEmitter<Partial<Activity>>();

    protected form: FormGroup;
    protected sharing = new FormControl(null);

    protected uploading = false;
    protected shareableDefaults: Shareable = null;

    protected $tags = toSignal(this.http.get<Entity[]>(`/api/label/tag/${LabelType.File}`), { initialValue: [] });

    protected MasterDetailEditorDisplayMode = MasterDetailEditorDisplayMode;
    protected LabelType = LabelType;

    constructor(
        private currentUserService: CurrentUserService,
        private dialogService: DialogService,
        private elementRef: ElementRef,
        private builder: FormBuilder,
        private http: HttpClient
    ) {

        this.form = this.builder
            .group({
                attachments: [null, Validators.required],
                shared: [null],
                systemSharing: [true],
                sensitive: [false],
                tags: [null]
            });

        this.sharing.valueChanges
            .pipe(
                takeUntilDestroyed(),
                tap(x => {
                    this.form.patchValue(x);
                })
            )
            .subscribe();

    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.elementRef.nativeElement.focus();
        });


    }

    ngOnDestroy(): void { }

    protected dismiss() {
        this.dialogService.dismissModal();
    }

    protected onSave() {

        const formData = this.form.value;
        const context = this.$context();

        const activity = {
            _id: null,
            kind: ActivityKind.File,
            type: ActivityType.File,
            system: false,
            active: true,

            note: null,

            systemSharing: formData?.systemSharing,
            shared: formData?.shared ?? [],
            sensitive: formData?.sensitive,
            labels: formData.tags,

            tags: context.activityTags,
            entity: context.entity,
            entityId: context.entityId,

            createdBy: this.currentUserService.user,
            createdDate: DateTime.local().setZone(context?.timezone).toJSDate(),

            attachments: formData.attachments,

        } as Activity;

        this.dialogService.dismissModal();
        this.save.emit(activity);
        console.log(activity);

    }

    protected onUploading(uploading: boolean) {
        this.uploading = uploading;
    }

    protected onShare(value: Shareable) {
        this.form.patchValue(value);
    }

    @HostListener('keydown', ['$event'])
    onKeydown(event: KeyboardEvent) {

        if (event.key === 'Escape') {
            event.stopPropagation();
            this.dismiss();
        }

    }

}